import { useMemo } from "react";
import { useQuery } from "@grandvisionhq/graphql";
import { toAppointment } from "../../../mappers/Appointments/mappers/appointment.js";
import { GET_APPOINTMENT_BY_ID } from "../../../operations/queries/Appointments/operations/queries/get-appointment-by-id.js";
const useGetAppointmentById = (id) => {
  const { data, loading, error } = useQuery(GET_APPOINTMENT_BY_ID, {
    variables: { id }
  });
  return useMemo(
    () => ({
      data: toAppointment(data?.appointment),
      loading,
      error
    }),
    [data, error, loading]
  );
};
export {
  useGetAppointmentById
};
//# sourceMappingURL=useGetAppointmentById.js.map
